
<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} {{aLang.sdr_title}}
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
          <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item :label="aLang.sdr_register_code">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'du_lieu_khai_bao.user_account'
                          ]
                        "
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>

                  <b-col md="3">
                    <el-form-item :label="aLang.sdr_safe_destination_name">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.ten'
                          ]
                        "
                        clearable
                      ></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item :label="aLang.sdr_safe_destination_type">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value.loai_diem_den
                        "
                        :placeholder="aLang.c_select"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listLoaiDDAT"
                          :key="item.code"
                          :label="item.text"
                          :value="item.code"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>

                  <b-col md="3" v-if="!aRole('SVHTT') && !aRole('PVHTT')">
                    <el-form-item :label="aLang.sdr_province">
                      <el-select
                        @change="changeProvince"
                        @clear="clearProvince"
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.dia_chi.tinh_id'
                          ]
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listProvince"
                          :key="item.id"
                          :value="item.id"
                          :label="item.name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <!-- <b-col md="3" v-if="!aRole('PVHTT')">
                    <el-form-item :label="aLang.sdr_district">
                      <el-select
                        @change="changeDistrict"
                        @clear="clearDistrict"
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.dia_chi.huyen_id'
                          ]
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listDistrict"
                          :key="item.id"
                          :value="item.id"
                          :label="item.name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->
                  <b-col md="3">
                    <el-form-item :label="aLang.sdr_commune">
                      <el-select
                        v-model="
                          mData.tableRules.dataSearch.value[
                            'thong_tin_chung.dia_chi.xa_id'
                          ]
                        "
                        :placeholder="aLang.c_select"
                        clearable
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listCommune"
                          :key="item.id"
                          :value="item.id"
                          :label="item.name"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="8" class="p-0">
            <b-col md="4"></b-col>
          </b-col>
          <b-col md="4">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
              <!-- <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>

        <b-row v-if="mData.dataDefault.error">
          <b-col md="12" class="mb-2">
            <el-alert :title="mData.dataDefault.error" type="error" show-icon></el-alert>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>

          <el-table-column
            prop="du_lieu_khai_bao.user_account"
            :label="aLang.sdr_register_code"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="thong_tin_chung.ten"

            :label="aLang.sdr_safe_destination_name"
            min-width="180"
          ></el-table-column>
          <el-table-column
            prop="ten_loai_diem_den"

            :label="aLang.sdr_safe_destination_type"
            min-width="130"
          ></el-table-column>
          <el-table-column
            prop="thong_tin_chung.giay_to.so_giay_to"

            :label="aLang.sdr_tax_code"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="thong_tin_chung.dia_chi.dia_chi"

            :label="aLang.sdr_address"
            min-width="180"
          ></el-table-column>
           <el-table-column
            prop="star"
            :sortable="mData.tableRules.allowSorting"
            :label="aLang.sdr_evaluate"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{fn_formatterNumber(scope.row.star,1)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            :label="aLang.sdr_number_of_evaluate"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              {{fn_formatterNumber(scope.row.count,0)}}
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="thoi_diem_tao"
            :sortable="mData.tableRules.allowSorting"
            :formatter="fn_formatterDatetime"
            label="Thời điểm tạo"
            width="150"
            align="center"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="duyet.duocduyet"
            :sortable="mData.tableRules.allowSorting"
            label="Duyệt"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.duyet.duoc_duyet"
                @change="fn_changeTrangThaiDuyet(scope.row.id, scope.row.duyet.duoc_duyet,scope.row.nguoi_tao_id)"
                disabled
              ></el-checkbox>
            </template>
          </el-table-column> -->
          <el-table-column :label="aLang.c_action" align="center" width="80px">
            <template slot-scope="scope">
               <el-button
                size="mini"
                @click="fn_goDanhGia('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="'Xem đánh giá'"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <!-- <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button> -->

              <!-- <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>-->
              <!-- <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DanhGiaDDATModel from "./DanhGiaDDATModel";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import DanhGiaApi from "../../../moduleApi/DanhGiaApi";
import AccountApi from "../../../moduleApi/AccountApi";
import ProvinceApi from '../../../moduleApi/ProvinceApi';
import DistrictApi from '../../../moduleApi/DistrictApi';
import CommuneApi from '../../../moduleApi/CommuneApi';
import UserSVHTTApi from '../../../moduleApi/UserSVHTTApi';
import UserPVHTTApi from '../../../moduleApi/UserPVHTTApi';

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DanhGiaDDAT", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DanhGiaDDATModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          listLoaiDDAT: DataService.loaiHinhRegister,
          listStar: [],
          listDDAT: [],
          listTrangThai: [
            {
              code: "true",
              text: "Đã duyệt"
            },
            {
              code: "false",
              text: "Chưa duyệt"
            }
          ],
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          isDistrictDisabled: true,
          isCommuneDisabled: true,
          error: ""
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
      }
    };
  },

  methods: {
    async fn_initTable() {
      let dataFilter = {
        account : this.mData.tableRules.dataSearch.value['du_lieu_khai_bao.user_account'],
        loai : this.mData.tableRules.dataSearch.value.loai_diem_den,
        ten: this.mData.tableRules.dataSearch.value['thong_tin_chung.ten'],
        tinh_id : this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.tinh_id'],
        // huyen_id : this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.huyen_id'],
        xa_id : this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.xa_id'],

      };
      if(this.aRole("SVHTT")){
        const userSVHTTApiRes = await UserSVHTTApi.findById(this.mData.currentUser.id);
        dataFilter.tinh_id = userSVHTTApiRes.result.province_id;
        // this.getDistrictList(userSVHTTApiRes.result.province_id);
      }
      if(this.aRole("PVHTT")){
        const userPVHTTApiRes = await UserPVHTTApi.findById(this.mData.currentUser.id);
        dataFilter.tinh_id = userPVHTTApiRes.result.province_id;
        // dataFilter.huyen_id = userPVHTTApiRes.result.district_id;
        this.getCommuneList(userPVHTTApiRes.result.province_id);
      }
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort_type = this.mData.tableRules.sort_type;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch,
          }
        });
      }

      let res = await DanhGiaApi.getSortableStarForSafePlace(dataFilter);

      // this.mData.dataDefault.listStar=res.result;
      let doiTuongDanhGias = MethodService.findListItemDifferent(
        res.result,
        "doi_tuong_id"
      );
      let resDD = await DiemDenAnToanApi.list({
        filters:"id:in:"+doiTuongDanhGias.join(','),
        limit:doiTuongDanhGias.length
      });
      this.mData.dataDefault.listDDAT = resDD.result;

      this.mData.tableRules.data = this.changeData(res.result);

      this.mData.tableRules.page = this.mData.tableRules.offset / this.mData.tableRules.limit + 1;

      let resTotal = await DanhGiaApi.getSortableStarForSafePlaceTotal(dataFilter);
      this.mData.tableRules.total = resTotal.result.length ? resTotal.result[0].total : 0;
      // if (
      //   this.mData.tableRules.offset == res.meta.total &&
      //   this.mData.tableRules.offset != 0
      // ) {
      //   this.mData.tableRules.offset = 0;
      //   this.mData.tableRules.page = 1;
      //   this.fn_initTable();
      // }
      // debugger;

    },
    changeData(data) {
      // let data1=MethodService.checkDifferentObject(MethodService.copyObject(DanhGiaDDATModel.dataForm),data);
      // debugger
      data.forEach((item) => {

        let resFind=this.mData.dataDefault.listDDAT.find(
          element => {
            return element.id == item.doi_tuong_id;
          }
        );
        if (resFind) {
          item.duyet = resFind.duyet;
          item.loai_diem_den=resFind.loai_diem_den;
          item.thong_tin_chung=resFind.thong_tin_chung;
          item.du_lieu_khai_bao=resFind.du_lieu_khai_bao;
        } else {
          item.duyet = MethodService.copyObject(DanhGiaDDATModel.dataForm.duyet);
          item.loai_diem_den=MethodService.copyObject(DanhGiaDDATModel.dataForm.loai_diem_den);
          item.thong_tin_chung=MethodService.copyObject(DanhGiaDDATModel.dataForm.thong_tin_chung);
          item.du_lieu_khai_bao=MethodService.copyObject(DanhGiaDDATModel.dataForm.du_lieu_khai_bao);
        }


        let tenLoai = this.mData.dataDefault.listLoaiDDAT.find(
          element => element.code == item.loai_diem_den
        );
        if (tenLoai) {
          item.ten_loai_diem_den = tenLoai.text;
        } else {
          item.ten_loai_diem_den = "";
        }


      });
      //  debugger;
      return data;
    },



    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
      if (type == "disable") {
        this.$confirm(LanguageService.lang.user_disableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, true);
          })
          .catch(() => {});
      }
      if (type == "openDisable") {
        this.$confirm(LanguageService.lang.user_openDisableConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_disable(row.id, false);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await DiemDenAnToanApi.delete(id);
      this.fn_initTable();
    },

    //khóa tài khoản
    async fn_disable(id) {
      await AccountApi.disable(id);
    },

    async fn_changeTrangThaiDuyet(id, trangThai, nguoiTaoId) {
      let duyetData = {
        duoc_duyet: trangThai
      };
      let data = {
        id: id,
        duyet: duyetData
      };

      if (trangThai) {
        try {
          await DiemDenAnToanApi.updateDuyet(data);
          await AccountApi.undisable(nguoiTaoId, "hidden");
          this.mData.dataDefault.error = null;
        } catch (e) {
          if (e.code == 401 && e.subCode == 140) {
            this.mData.dataDefault.error = "Mã số thuế này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
            // toastr.error('Mã số thuế này đã đăng ký');
          } else if(e.code == 401 && e.subCode == 141) {
            // toastr.error('Tên điểm đến và Địa chỉ này đã đăng ký');
            this.mData.dataDefault.error = "Tên điểm đến và Địa chỉ này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
          } else if(e.code == 401 && e.subCode == 142) {
            // toastr.error('Tên điểm đến và Xã này đã đăng ký');
            this.mData.dataDefault.error = "Tên điểm đến và Xã này đã đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
          } else if(e.code == 401 && e.subCode == 143) {
            // toastr.error(' Số điện thoại này đã được đăng ký');
            this.mData.dataDefault.error = " Số điện thoại này đã được đăng ký. Vui lòng liên hệ số 0906150276 để được hỗ trợ.";
          } else {
            this.mData.dataDefault.error = "Đăng ký người dùng không thành công";
            // toastr.error('Đăng ký người dùng không thành công');
          }
        }
      } else {
        await DiemDenAnToanApi.updateHuyDuyet(data);
        await AccountApi.disable(nguoiTaoId, "hidden");
      }
      this.fn_initTable();
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      // debugger
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );

          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_goDanhGia(type, scope, row) {
      if (type == "detail") {
        localStorage.setItem('prevUrl', this.$router.currentRoute.path);

        this.$router.push({
          name: "Admin-DanhGiaDDATDetail-list",
          query: {
            filters: "loai_doi_tuong_danh_gia=safe_place&doi_tuong_danh_gia_id=" + row.doi_tuong_id,
            doi_tuong_danh_gia_id: row.doi_tuong_id,
             loai_doi_tuong_danh_gia:  'safe_place'
          },
          // params: {
          //   benh_id: row.id
          // }
        });
      }
    },


    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    fn_formatterNumber(cellValue, dec) {
      if (typeof cellValue == "number") {
        if (!(dec && typeof cellValue == "number")) dec = 0;
        return cellValue
          .toFixed(dec)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ",");
      }
    },

    async fn_initDataDefault() {},

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },


    changeProvince(province, clear = true) {
      this.getCommuneList(province);
      this.mData.dataDefault.listCommune = [];
      this.mData.dataDefault.isDistrictDisabled = false;
      this.mData.dataDefault.isCommuneDisabled = true;
      if (clear) {
        // this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.huyen_id'] = null;
        this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.xa_id'] = null;
      }
    },

    clearProvince() {
      this.mData.dataDefault.listDistrict = [];
      this.mData.dataDefault.listCommune = [];
      // this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.huyen_id'] = null;
      this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.xa_id'] = null;
    },

    // changeDistrict(district, clear = true) {
    //   this.getCommuneList(district);
    //   if (clear) {
    //     this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.xa_id'] = null;
    //   }
    // },

    clearDistrict() {
      this.mData.dataDefault.listCommune = [];
      this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.xa_id'] = null;
    },

    async getProvinceList() {
      let province = await ProvinceApi.list({limit: 1000});
      if (province.result.length > 0) {
        this.mData.dataDefault.listProvince = province.result;
      }
    },

    // async getDistrictList(provinceId) {
    //   let district = await DistrictApi.list({filters: [`provinceId=${provinceId}`], limit: 1000});
    //   if (district.result.length > 0) {
    //     this.mData.dataDefault.listDistrict = district.result;
    //   }
    // },

    async getCommuneList(provinceId) {
      let commune = await CommuneApi.list({filters: [`provinceId=${provinceId}`],limit: 1000});
      if (commune.result.length > 0) {
        this.mData.dataDefault.listCommune = commune.result;
      }
    }
  },


  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();

    this.getProvinceList();
  },
  mounted() {
    this.fn_initTable();

    if (this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.tinh_id']){
      this.changeProvince(this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.tinh_id'], false);
    }
    // if (this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.huyen_id']){
    //   this.changeDistrict(this.mData.tableRules.dataSearch.value['thong_tin_chung.dia_chi.huyen_id'], false);
    // }
  }
};
</script>
